import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="16"
        viewBox="0 0 16 16"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M4.38365 13.583L3.5434 3.5H12.4566L11.6163 13.583C11.5732 14.1013 11.1399 14.5 10.6198 14.5H5.3802C4.86011 14.5 4.42684 14.1013 4.38365 13.583Z"
            stroke="currentColor"
        />
        <path
            d="M5.5 3.5V2.5C5.5 1.94772 5.94772 1.5 6.5 1.5H9.5C10.0523 1.5 10.5 1.94772 10.5 2.5V3.5"
            stroke="currentColor"
            strokeLinecap="round"
        />
        <path d="M2.5 3.5H13.5" stroke="currentColor" strokeLinecap="round" />
    </svg>
);

export default Icon;
